import React, { useEffect } from 'react';
import { LogoLoadingIndicator } from '@/components/logo-loading-indicator';
import { PricingItemManagementScreen } from '@/experiences/sales-portal/domain/pricing/screens/management/pricing-item-management-screen';
import { SALES_PORTAL_ROUTES } from '@/navigators/routes';
import { SalesPortalStackParams } from '@/navigators/types';
import { StackNavigationProp, StackScreenProps } from '@react-navigation/stack';
import { useBusinessOrganizationPricingConfig } from '@/experiences/sales-portal/blocs/hooks/use-business-organization-pricing-config';
import { useNavigation } from '@react-navigation/native';
import { validate } from 'uuid';

type Props = StackScreenProps<
  SalesPortalStackParams,
  typeof SALES_PORTAL_ROUTES.PricingItemManagement
>;

export const PricingItemManagementScreenWrapper: React.FC<Props> = (props) => {
  const navigation =
    useNavigation<StackNavigationProp<SalesPortalStackParams>>();
  const { variantPackUUID } = props.route.params;
  const isVariantPackUUIDValid = validate(variantPackUUID);

  const { loading, error, hasPricingAccess } =
    useBusinessOrganizationPricingConfig();

  useEffect(() => {
    const accessDenied = !loading && !error && !hasPricingAccess;
    if (!isVariantPackUUIDValid || accessDenied) {
      navigation.replace(SALES_PORTAL_ROUTES.NotFound);
    }
  }, [error, hasPricingAccess, isVariantPackUUIDValid, loading, navigation]);

  if (!isVariantPackUUIDValid) {
    return null;
  }

  return loading ? (
    <LogoLoadingIndicator />
  ) : (
    <PricingItemManagementScreen {...props} />
  );
};
